import React,{useState} from "react";
import { Modal } from "react-bootstrap";
import WithdrawItems from "./items";
import Layout from "../layout/layout";
import Search from "./search";
import CustomPrice from "./customprice";
import TradeOffer from "./tradeoffer";






const Deposit = () => {

    const [show, setShow] = useState(false);
    const [view, setview] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleViewClose = () => setview(false);
    const handleViewShow = () => setview(true);


    return (
        <Layout>
            <div className="withraw-page">

                <Search />

                <WithdrawItems handleShow={handleShow} handleViewShow={handleViewShow}/>

                <Modal dialogClassName="trade-popup" show={show} onHide={handleClose} centered>
                    <Modal.Header closeButton>
                    <Modal.Title>Send Trade Offer</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <CustomPrice />

                    </Modal.Body>
                    
                </Modal>


                <Modal dialogClassName="trade-popup" show={view} onHide={handleViewClose} centered>
                        <Modal.Header closeButton>
                        <Modal.Title>Send Trade Offer</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>

                            <TradeOffer />

                        </Modal.Body>
                        
                    </Modal>



            </div>
     
        </Layout>
    );
};

export default Deposit;